import React from "react";

/**
 * Edit Content Button component
 */
const EditContentButton = ({ onClick }) => {
  return (
    <div style={{ marginTop: "24px" }}>
      <button
        style={{
          width: "100%",
          height: "40px",
          backgroundColor: "white",
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          border: "2px solid #0056b3",
          color: "#0056b3",
        }}
        onClick={onClick}
      >
        Edit Content
      </button>
    </div>
  );
};

export default EditContentButton;
